export default __webpack_public_path__ + "static/media/annex12.9b7bb698.png";